import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import CreatedDate from './created-date'
import UpdatedDate from './updated-date'

const EditReflectionForm = ({
    userReflection = {},
    onComplete = () => {}
}) => {

    const { content } = userReflection

    return (
        <React.Fragment>
            <div style={{ padding: '20px', marginTop: '20px'}}>
                <Form.Group>
                    <Form.Label>{userReflection.name}</Form.Label>
                    <div>{userReflection.description}</div>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Reflection:</Form.Label>
                    <div style={{ color: 'black' }}>{content || '- nothing written -'}</div>
                </Form.Group>
                <CreatedDate userReflection={userReflection} />
                <UpdatedDate userReflection={userReflection} />
                <Row>
                    <Col xs={12}>
                        <Button block onClick={() => onComplete()}>CLOSE</Button>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default EditReflectionForm